import { createElementBlock as t, openBlock as n, createElementVNode as a, Fragment as c, renderList as m, createVNode as u, unref as r, withCtx as p, createTextVNode as g, toDisplayString as o } from "vue";
import { useTracking as f } from "../../../composables/useTracking.js";
/* empty css                                 */
import y from "../../../atoms/anchor-element/anchor-element.vue.js";
const _ = { class: "ds-display-flex ds-align-items-center ds-flex-wrap" }, x = {
  class: "ds-display-flex ds-align-items-center",
  role: "menubar"
}, w = {
  class: "ds-text-small ds-color-grey-3200",
  "data-j-copyright": ""
}, F = /* @__PURE__ */ Object.assign({
  name: "DsFooterSecondaryNavigation"
}, {
  __name: "footer-secondary-navigation",
  props: {
    items: { type: Array, required: !0 }
  },
  setup(s) {
    const { trackingDataProvided: i } = f();
    return (l, k) => (n(), t("div", _, [
      a("nav", null, [
        a("ul", x, [
          (n(!0), t(c, null, m(s.items, (e, d) => (n(), t("li", {
            key: `secondary-navigation-item-${d}`,
            class: "ds-display-flex ds-text-small",
            role: "none"
          }, [
            u(r(y), {
              url: e.url,
              "open-in-new-window": e.openInNewWindow,
              nuxt: e.nuxt,
              "tracking-data": { "component-name": l.$options.name, text: e.title, ...r(i) },
              class: "ds-footer-secondary-navigation-link ds-margin-right-12",
              role: "menuitem"
            }, {
              default: p(() => [
                g(o(e.title), 1)
              ]),
              _: 2
            }, 1032, ["url", "open-in-new-window", "nuxt", "tracking-data"])
          ]))), 128))
        ])
      ]),
      a("p", w, " © " + o((/* @__PURE__ */ new Date()).getFullYear()) + " Adyen ", 1)
    ]));
  }
});
export {
  F as default
};
